import * as React from 'react'

import { Box, Button, useToggle } from '@factorialco/deprecated-design-system'

import Popover from 'modules/core/components/Popover'
import PopoverContent from 'modules/core/components/Popover/Content'
import useAsyncAction from 'modules/core/hooks/useAsyncAction'
import i18n from 'modules/core/lib/i18n'

import { SurveyParticipantsContext } from 'modules/surveys/pages/Show/Participants/hooks'
import { useSurveyShowContext } from 'modules/surveys/pages/Show/hooks'
import formAccessGroupMemberships from 'modules/surveys/store/collections/formAccessGroupMemberships'

interface EditButtonProps {
  participantId: string
  canHaveSettings: boolean
}

function EditButton({ participantId, canHaveSettings }: EditButtonProps) {
  const { form, survey, hasSurveyV2, updateCanBeStarted, canEditSurvey } = useSurveyShowContext()
  const [open, toggle] = useToggle()
  const surveyModel = hasSurveyV2 ? survey : form
  const canEdit = !!surveyModel && canEditSurvey && surveyModel.isDraft
  const { accessGroup } = React.useContext(SurveyParticipantsContext)
  const membership =
    !!accessGroup &&
    formAccessGroupMemberships.find({
      access_id: participantId,
      access_group_id: accessGroup.attributes.id,
    })

  const { performAction: destroy } = useAsyncAction(async () => {
    if (membership && surveyModel) {
      await membership?.destroy({ data: { form_id: surveyModel.attributes.id } })

      const membershipToDeleteInCollection = formAccessGroupMemberships.find({
        access_id: participantId,
        access_group_id: accessGroup?.attributes.id,
      })
      membershipToDeleteInCollection &&
        formAccessGroupMemberships.remove(membershipToDeleteInCollection)
      await updateCanBeStarted()
    } else {
      return null
    }
  })

  if (!surveyModel || !membership || !canEdit || !canHaveSettings) return null

  return (
    <Popover attachment="top right" targetAttachment="bottom center" toggle={toggle} open={open}>
      <Button onClick={toggle(true)} type="secondary" iconName="ellipsis" />
      <PopoverContent
        onClose={toggle(false)}
        options={[
          {
            title: i18n.t('surveys.form.participants.table.body.edit.delete.survey'),
            type: 'wrong',
            onClick: destroy,
          },
        ]}
      />
    </Popover>
  )
}

interface Props {
  participantId: string
  canHaveSettings: boolean
}

export default function Settings({ participantId, canHaveSettings }: Props) {
  return (
    <Box justifyContent="flexEnd" flexDirection="row">
      <EditButton participantId={participantId} canHaveSettings={canHaveSettings} />
    </Box>
  )
}
